var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2913 14.6629C17.2913 14.6629 13.2826 18.6716 10.3085 21.6457C9.47359 22.4807 8.34124 22.9497 7.16047 22.9497C5.97974 22.9497 4.84735 22.4807 4.01243 21.6457C2.27385 19.9071 2.27385 17.0883 4.01243 15.3497C6.32794 13.0342 9.41213 9.95001 11.4375 7.92462C11.9973 7.36484 12.7566 7.05031 13.5483 7.05031C14.3399 7.05031 15.0992 7.3648 15.659 7.92462L15.6592 7.92474C16.8249 9.0905 16.8249 10.9805 15.6592 12.1463C13.4101 14.3953 9.93895 17.8665 8.19782 19.6076C7.60492 20.2005 6.64372 20.2005 6.05083 19.6076C6.05075 19.6075 6.05066 19.6074 6.05058 19.6073C5.45773 19.0145 5.45773 18.0532 6.05058 17.4604C8.37959 15.1314 13.6886 9.82235 13.6886 9.82235",
    stroke: "#576473",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#0B907B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5245 8V7.42898L19.0394 5.94389C19.1843 5.79759 19.305 5.66761 19.4016 5.55398C19.4982 5.44034 19.5707 5.33026 19.619 5.22372C19.6673 5.11719 19.6914 5.00355 19.6914 4.88281C19.6914 4.74503 19.6602 4.62713 19.5977 4.52912C19.5352 4.42969 19.4492 4.35298 19.3398 4.29901C19.2305 4.24503 19.1062 4.21804 18.967 4.21804C18.8235 4.21804 18.6978 4.24787 18.5898 4.30753C18.4819 4.36577 18.3981 4.44886 18.3384 4.55682C18.2802 4.66477 18.2511 4.79332 18.2511 4.94247H17.4989C17.4989 4.66548 17.5621 4.42472 17.6886 4.22017C17.815 4.01562 17.989 3.85724 18.2106 3.74503C18.4336 3.63281 18.6893 3.5767 18.9776 3.5767C19.2702 3.5767 19.5273 3.63139 19.7489 3.74077C19.9705 3.85014 20.1424 4 20.2646 4.19034C20.3881 4.38068 20.4499 4.59801 20.4499 4.84233C20.4499 5.00568 20.4187 5.16619 20.3562 5.32386C20.2937 5.48153 20.1836 5.65625 20.0259 5.84801C19.8697 6.03977 19.6502 6.27202 19.3675 6.54474L18.6154 7.30966V7.33949H20.516V8H17.5245Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.ec09b1640707c80e6443f589f6523d51.svg";
export { ForwardRef as ReactComponent };